import HomeSidebar from "../../components/Sidebars/Home";
import { Team } from "types";
import Icon from "../../icons";
import 'tippy.js/dist/tippy.css';
import { Link } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import AppHomeList from "./List/Teams";
import AppHomeDiscoverTeams from "./List/DiscoverTeams";
import AppHomeUserApplications from "./List/MyApplications";
import ErrorBoundary from "@/ErrorBoundary";
import { useQueryClient } from "@tanstack/react-query";
import FriendsList from "./List/Friends";

export default function AppHome({ socket, isOpen }: { socket: any, isOpen: number }) {
    const [, setTeams] = useState<any[]>([]);
    const queryClient = useQueryClient();
    const user = queryClient.getQueryState(["user"]) as any;

    const handleSocketMessage = useCallback(async (event: MessageEvent) => {
        const data = JSON.parse(event.data);
        if (data.t == "USER_JOINED_TEAM" && data.d.member?.id == user?.id) {
            setTeams((prev) => [...prev, data.d.team]);
        } else if (data.t == "USER_LEFT_TEAM" && data.d.member.id == user.id) {
            setTeams((prev) => prev.filter((team: Team) => team.id != data.d.team.id));
        } else if (data.t == "TEAM_UPDATED") {
            setTeams((prev) => prev.map((team: Team) => team.id == data.d.team.id ? data.d.team : team));
        } else if (data.t == "TEAM_DELETED") {
            setTeams((prev) => prev.filter((team: Team) => team.id != data.d.teamId));
        }
    }, [user]);

    useEffect(() => {
        if (!socket) return;

        socket.addEventListener("message", handleSocketMessage);

        return () => {
            socket.removeEventListener("message", handleSocketMessage);
        };
    }, [socket, handleSocketMessage]);
      
  
    return (
        <>
            <HomeSidebar socket={socket} isOpen={isOpen} />
            <div className="flex-0 space-y-6 w-full max-h-screen overflow-hidden">
                <ErrorBoundary>
                    <div className="bg-brand-dark/0">
                    {window.location.pathname == "/" ? (
                        <AppHomeList />
                    ) : window.location.pathname == "/discover/teams" ? (
                        <AppHomeDiscoverTeams />
                    ) : window.location.pathname == "/me/applications" ? (
                        <AppHomeUserApplications />
                    ) : window.location.pathname == "/me/friends" ? (
                        <FriendsList />
                    ) : (
                        <div className="flex flex-col gap-4 p-4">
                            <div className="items-center flex flex-col gap-2 h-screen justify-center">
                                <div className="text-gray-300 relative font-semibold text-9xl">
                                    <h1>🔎</h1>
                                    <h1 className="absolute top-8 left-20 text-4xl text-white">
                                        <Icon name="trophy" size={"42"} />
                                    </h1>
                                </div>
                                <h1 className="text-gray-300 font-semibold text-2xl">This page not ready yet</h1>
                                <p className="text-gray-300">This page is not ready yet, please check back later</p>
                                <Link to="/" className="bg-brand-green text-white px-4 py-2 rounded-lg">Go Home</Link>
                            </div>
                        </div>
                    )}
                    </div>
                </ErrorBoundary>
            </div>
        </>
    );
}
